import axios from 'utils/axios';
import { put } from 'redux-saga/effects';
import * as CurrentUser from 'actions/CurrentUser';
import { toastr } from 'react-redux-toastr'
import i18n from 'i18n/i18n.js';

export function* onGetRequest(parmas) {
  const { cb } = parmas || {};
  try {
    const currentUser = yield axios.get(`/api/student/current`);
    yield put(CurrentUser.onGetSuccess(currentUser.data || {}));
    cb && cb(null, currentUser.data);
  } catch (e) {
    yield put(CurrentUser.onGetFailure({ message: e.toString(), error: e }));
    cb && cb(e);
  }
}

export function* onSetLanguageRequest(params) {
  const { cb } = params || {};
  try {
    const language = yield axios.post(`/api/student/setLanguage`, `"${params.params}"`);
    yield put(CurrentUser.onSetLanguageSuccess(language.data || {}));
    cb && cb(null, language.data);
  } catch (e) {
    yield put(CurrentUser.onSetLanguageFailure({ message: e.toString(), error: e }));
    cb && cb(e);
  }
}

export function* onSetProfilePictureRequest({ payload }) {

  const { profilePicture, cb } = payload || {};

  try {
    const data = new FormData();

    if(profilePicture) {
      data.append('file', profilePicture);
    }

    const { data: rs } = yield axios.post('/api/student/setProfilePicture', data);
    yield put(CurrentUser.onSetProfilePictureSuccess(rs || {}));
    toastr.success(i18n.t('toastr.onSetProfilePictureRequest.title'), i18n.t('toastr.onSetProfilePictureRequest.body'))
    cb && cb(null, profilePicture);
  } catch (e) {
    yield put(CurrentUser.onSetProfilePictureFailure({ message: e.toString(), error: e }));
    cb && cb(null, e);
  }
}
